import { render, staticRenderFns } from "./goalCard.vue?vue&type=template&id=997bbc96&scoped=true"
import script from "./goalCard.vue?vue&type=script&lang=js"
export * from "./goalCard.vue?vue&type=script&lang=js"
import style0 from "./goalCard.vue?vue&type=style&index=0&id=997bbc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997bbc96",
  null
  
)

export default component.exports